import { render, staticRenderFns } from "./Persons.vue?vue&type=template&id=373f01d8&"
import script from "./Persons.vue?vue&type=script&lang=js&"
export * from "./Persons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports